import classnames from 'classnames';
import { SfaPlayerStatusChipProps } from './sfaPlayerStatusChip.types';
import styles from './sfaPlayerStatusChip.module.scss';

const variantLabel: Record<string, string> = {
  captain: 'Captain',
  viceCaptain: 'Vice captain',
  custom: 'Player status',
};

const SfaPlayerStatusChip = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-player-status-chip',
  icon,
  variant = 'captain',
  label,
}: SfaPlayerStatusChipProps) => {
  // When there's no visible label the icon-only chip needs an accessible
  // name. Use the variant string as a fallback aria-label.
  const accessibleLabel = label ?? variantLabel[variant] ?? 'Player status';

  return (
    <span
      {...nativeProps}
      data-testid={testId}
      className={classnames(styles.sfaPlayerStatusChip, classNames)}
      role="img"
      aria-label={accessibleLabel}
    >
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      {label ? <span className={styles.label}>{label}</span> : null}
    </span>
  );
};

export default SfaPlayerStatusChip;
